export const mspRoutes = {
  path: "/msp",
  component: () => import("@/layouts/Msp/MspLayout.vue"),
  children: [
    {
      path: "/msp/dashboard",
      name: "msp-dashboard",
      component: () => import("@/modules/Dashboard/views/Msp"),
      redirect: {
        name: "msp-dashboardOverview",
      },
      children: [
        {
          path: "",
          name: "msp-dashboardOverview",
          component: () => import("@/modules/Dashboard/views/Msp/index.vue"),
        },
      ],
    },
  ],
};

export default {};
